import { Reducer } from "redux";
import { DashboardState } from "../models/dashboardModel";
import actionTypes from '../types/dashboardTypes';

const initailState: DashboardState = {
    pbiData: null,
    dashboardFilter: {},
    dashboardType: '',
    isFilterApplied: false,
};

const dashboardReducer: Reducer = (state: DashboardState = initailState, action: any): any => {
    switch (action.type) {
        case actionTypes.SET_PBI_DASHBOARD_DATA: {
            return {
                ...state,
                pbiData: action.payload,
            };
        }
        case actionTypes.SET_DASHBOARD_FILTER: {
            return {
                ...state,
                dashboardFilter: action?.payload?.dashboardFilter,
                dashboardType: action?.payload?.dashboardType,
                isFilterApplied: action?.payload?.dashboardFilter?.fromMonth || action?.payload?.dashboardFilter?.toMonth
            };
        }
        default: return state;
    }
}

export default dashboardReducer;